import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { ITransactionFinalization } from 'features/transaction-details/types';
import {
	formatFinalizationLine,
	sortFinalizationsChronologically,
} from 'features/transaction-details/helpers/finalizationCopy';

interface TransactionFinalizationNotesProps {
	finalizations: ITransactionFinalization[];
	coinCode: string;
}

export const TransactionFinalizationNotes = ({
	finalizations,
	coinCode,
}: TransactionFinalizationNotesProps): JSX.Element | null => {
	const sorted = useMemo(() => sortFinalizationsChronologically(finalizations), [finalizations]);

	if (sorted.length === 0) return null;

	const [first, ...rest] = sorted;

	return (
		<Box sx={{ flex: 1, minWidth: 0 }}>
			<Typography variant="caption" color="text.secondary" component="p" sx={{ lineHeight: 1.5 }}>
				{formatFinalizationLine(first, 0, coinCode)}
			</Typography>
			{rest.length > 0 && (
				<Box component="ul" sx={{ m: 0, mt: 0.75, pl: 2.25 }}>
					{rest.map((finalization, index) => (
						<Box component="li" key={finalization.id} sx={{ mb: 0.5 }}>
							<Typography variant="caption" color="text.secondary" component="span" sx={{ lineHeight: 1.5 }}>
								{formatFinalizationLine(finalization, index + 1, coinCode)}
							</Typography>
						</Box>
					))}
				</Box>
			)}
		</Box>
	);
};
